import config from "../../config.json";

export const currencyFormatter = (amount: number) => {
  const formatter = new Intl.NumberFormat(
    config[process.env.GATSBY_VM_MARKET]?.VM_MARKET_LOCALE || "en-AU",
    {
      style: "currency",
      currency: config[process.env.GATSBY_VM_MARKET]?.VM_CURRENCY_CODE || "AUD",
    }
  );
  const [wholeAmount, fractionAmount] = formatter.format(amount).split(".");
  const shouldIncludeFraction = fractionAmount !== "00";

  if (shouldIncludeFraction) {
    return `${wholeAmount}.${fractionAmount}`;
  }

  return wholeAmount;
};
